module.exports = __webpack_public_path__ + "img/Cement 480x480.53c979c3.png";